// npm
import React from 'react'

export default function NotFound() {
  return <p>404 - Not Found</p>
}
